module.exports = __webpack_public_path__ + "img/tms-side-panel-1-en.82df8861.svg";